import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { ReturnToMobileBanner as ReturnToMobileBannerType } from './ReturnToMobileBanner.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyReturnToMobileBanner = lazy<typeof ReturnToMobileBannerType>(
	() =>
		import(
			/* webpackChunkName: "async-return-to-mobile-banner" */ './ReturnToMobileBanner.tsx'
		).then(({ ReturnToMobileBanner }) => ReturnToMobileBanner),
	{
		entryFsSsrLiftImportToModule: true,
		// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
		includeInShellOnlySsrBundle: true,
		entryFsSsrOverride: 'include',
	},
);

export const ReturnToMobileBanner = () => (
	<Placeholder name="async-return-to-mobile-banner" fallback={null}>
		<LazyReturnToMobileBanner />
	</Placeholder>
);
